module.exports = __webpack_public_path__ + "static/media/fi.a814e980.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/fi.svg
// module id = 111
// module chunks = 0